import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '@angular/fire/auth';

export const AuthGuard: CanActivateFn = async () => {
  const auth   = inject(Auth);
  const router = inject(Router);

  // Espera a que Firebase restaure la sesión desde localStorage antes de decidir.
  // Sin esto, take(1) captura el null inicial y redirige al login incorrectamente.
  await auth.authStateReady();

  if (auth.currentUser) return true;

  router.navigate(['/auth/login']);
  return false;
};
